import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../../../assets/notifylog.png";
import useAuth from "../../../components/hooks/useAuth";
import { Form, Container } from "./styles";

const ComponentSignUp = () => {
  const [fullname, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [password, setPassword] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  let { signUp } = useAuth();
  const isValidFullName = (name) => {
    const parts = name.trim().split(/\s+/);
    return parts.length >= 2;
  };
  const normalizePhone = (phone) => {
    return phone.replace(/\D/g, "");
  };
  const validDDDs = [
    "11", "12", "13", "14", "15", "16", "17", "18", "19",
    "21", "22", "24", "27", "28",
    "31", "32", "33", "34", "35", "37", "38",
    "41", "42", "43", "44", "45", "46",
    "47", "48", "49",
    "51", "53", "54", "55",
    "61",
    "62", "64",
    "63",
    "65", "66",
    "67",
    "68",
    "69",
    "71", "73", "74", "75", "77",
    "79",
    "81", "87",
    "82",
    "83",
    "84",
    "85", "88",
    "86", "89",
    "91", "93", "94",
    "92", "97",
    "95",
    "96",
    "98", "99"
  ];
  const isValidBrazilPhone = (phone) => {
    let cleaned = phone.replace(/\D/g, "");

    // Remove +55 se vier
    if (cleaned.startsWith("55")) {
      cleaned = cleaned.substring(2);
    }

    // Agora deve ter 10 ou 11 dígitos
    if (cleaned.length !== 10 && cleaned.length !== 11) {
      return false;
    }

    const ddd = cleaned.substring(0, 2);
    if (!validDDDs.includes(ddd)) {
      return false;
    }

    // Se for celular (11 dígitos), precisa começar com 9
    if (cleaned.length === 11 && cleaned[2] !== "9") {
      return false;
    }

    return true;
  };
  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!fullname || !email || !whatsapp || !password) {
      setError("Preencha todos os dados para se cadastrar");
    } else if (!isValidFullName(fullname)) {
      setError("Digite seu nome e sobrenome");
      return;
    }
    else if (!isValidBrazilPhone(whatsapp)) {
      setError("Digite um número válido com DDD");
      return;
    }
    else {
      try {
        let res = await signUp(fullname, email, password, whatsapp);
        if (res.success == false) {
          setError(res.message.toString());
        } else {
          navigate("/app");
        }
      } catch (err) {
        setError("Ocorreu um erro ao registrar sua conta22. T.T");
      }
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSignUp}>
        <img src={Logo} alt="Airbnb logo" />
        {error && <p>{error}</p>}
        <input
          type="text"
          placeholder="Nome"
          value={fullname}
          onChange={(e) => setFullName(e.target.value)}
        />
        <input
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="tel"
          placeholder="WhatsApp"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Cadastrar agora</button>
        <hr />
      </Form>
    </Container>
  );
};

export default ComponentSignUp;
